"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./_internal/utils");
/**
 * @internal
 */
var pipe1 = function (a, f) {
    return (0, utils_1.isPromise)(a) ? a.then(f) : f(a);
};
exports.default = pipe1;
//# sourceMappingURL=pipe1.js.map